export default __webpack_public_path__ + "static/media/evenShotMascot.ad578317.png";